import 'dayjs/locale/zh-cn'

import dayjs from 'dayjs'
import { AnimatePresence, motion } from 'framer-motion'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { checkDevice } from '@/hooks/useCheckDevice'
import useInRoom from '@/hooks/useInRoom'
import { deviceInfoStore, useRecoilState, useSetRecoilState } from '@/store'

import Courseware from '../Courseware'
import ImgPlaceholder from '../ImgPlaceholder'
import Modal from '../Modal'
dayjs.locale('zh-cn')
const { deviceShowState, fromPageState } = deviceInfoStore

const LESSONTYPE = {
  1: '正式课',
  0: '试听课'
}

export default ({ data }: any) => {
  const [classState, setClassState] = useState(false)
  const [tipState, setTipState] = useState(false)
  const setDeviceShow = useSetRecoilState(deviceShowState)
  const [fromPage, setFromPage] = useRecoilState(fromPageState)
  const [to1v1Room] = useInRoom()

  const ittest = async () => {
    console.log('inRoom', data)
    // canClick: true
    // courseId: 3499
    // courseState: 2
    // cover: "https://s2.xiaoxiongmeishu.com/teach/dev/1v1/one/little_bear/images/57854710bf6011eb83ffbdf69580ee90.png"
    // date: "2022-08-27"
    // datetime: 1661577133
    // hour: "13:12-14:12"
    // id: 4732371
    // lessonstatus: 2
    // lessonType: "1" 0 -> 试听课，1-> 正式课
    // lessontype=1,info:1v1&试听课"
    // lessontype=2info:1V1G正式课"
    // lessontype=3,info:"1v1&单次课"
    // lessontype=4,info:1v16固定课"
    // lessontype=5info:“小班课&考级课"
    // lessontype=6,intfo:小班课&试听课"
    // lessontype=7.info:“小班课&正式单次课"
    // lessontype=8,info:小班课Q正式长期课"
    // lessontype=9,info:小班课&比赛课”
    // lessontype=10.info:"专题课”
    // lessontype=11,info:"美育课"
    // lessontype=12,info:“1v1&主题课单次课"
    // lessontype=13,info:^1v1&主题课长期课"
    // lessontype: 3
    // overseasOpen: 0
    // roomId: "729875131303858176"
    // teacherHead: "https://imgvip.meishubao.com/ke/upload/image/2020/04/08/dac56a623fae7a406b7aa3c46184db86.png"
    // teacherId: 1780930
    // teacherLevel: null
    // teacherName: "测老师"
    // teacher_id: 1780930
    // time: "20:00"
    // title: "高兴新版课件02"
    // uid: 4175037
    // week: "星期六"
    const formData = {
      beforeClassTime: 0,
      classroom: undefined,
      courseId: data.courseId,
      datetime: data.datetime,
      lessonDetailUrl: '',
      lessonStatusType: 1,
      lessonType: Number(data.lessonType || '1'),
      pushStatus: 0,
      recordId: 0,
      recordStage: null,
      roomId: data.roomId,
      s_title: null,
      sort: null,
      subjectName: null,
      teacher: data.teacherId,
      teaname: data.teacherName,
      time: data.date + ' ' + data.time,
      timesId: data.id,
      title: data.title,
      userId: data.uid,
      userName: localStorage.username,
      // 记住选择的摄像头
      masterCamera: localStorage.masterCamera,
      viceCamera: localStorage.viceCamera
    }
    setFromPage(formData)

    const res = await checkDevice()
    if (!res) {
      setTipState(true)
      return
    }
    inRoom(formData)
  }

  const inRoom = async (formData: any) => {
    to1v1Room(formData)
    setFromPage({})
  }

  const lookCourse = () => {
    if (data.isIndividualizationClass && data.isIndividualizationClass === 1) {
      window.open(data.lessonDetailUrl)
    } else {
      setClassState(true)
    }
  }

  return (
    <Fragment>
      <div className="w-[150px] h-[150px] rounded overflow-hidden">
        <ImgPlaceholder className="w-full h-full rounded anim_btn2 duration-300" src={data.cover} alt="" />
      </div>
      <div className="flex justify-between items-start flex-col flex-1 ml-[20px] h-[150px]">
        <div className="text-[20px] text-[#333]">
          {data.overseasOpen
            ? `${dayjs(data.datetime * 1000).format('YYYY年MM月DD日 dddd HH:mm')} -
                ${dayjs(data.datetime * 1000 + 3600000).format('HH:mm')}`
            : data.date
              ? `${data.date} ${data.week} ${data.hour}`
              : ''}
        </div>
        <div className="text-[24px] text-[#333] font-medium whitespace-nowrap text-ellipsis overflow-hidden max-w-[700px]">{data.title}</div>
        <div>
          <button
            disabled={!data.courseState}
            onClick={ittest}
            className=" disabled:opacity-[0.3] disabled:hover:scale-100 disabled:cursor-no-drop btn-style rounded-full px-[36px] py-[10px] text-[#FFF] anim_btn2"
          >
            进入教室
          </button>
          <button onClick={lookCourse} className="ml-[20px] rounded-full px-[36px] py-[9px] text-[#ff3300] bg-[#ffeee8] border-[#ff3300] border-[1px] border-solid anim_btn2">
            查看课件
          </button>
        </div>
      </div>
      <div className="flex justify-between items-end flex-col h-[150px]">
        <button className={`${data.lessonType === 0 ? ' text-[#ffb500] bg-[#fff5dc]' : ' text-[#ff3300] bg-[#ffeee8]'} rounded min-w-[80px] px-[4px] h-[30px] flex items-center justify-center`}>
          {data.isIndividualizationClass === 1 ? '个性化约课' : LESSONTYPE[data.lessonType] || '正式课'}
        </button>
        <div className="flex items-center justify-center">
          <ImgPlaceholder className="rounded-full w-[36px] h-[36px]" src={data.teacherHead} alt="" />
          <span className="ml-[10px] text-[16px] text-[#969696]">{data.teacherName}</span>
        </div>
      </div>

      <Modal show={classState} cancel={() => setClassState(false)} header="" cancelText="好的" className="class-modal">
        <Courseware courseId={data.courseId} />
      </Modal>

      <Modal
        shadowClick={false}
        show={tipState}
        cancel={() => {
          setTipState(false)
          inRoom(fromPage)
        }}
        header=""
        confirm={() => {
          setTipState(false)
          setDeviceShow(true)
        }}
        cancelText="暂不检测"
      >
        <div className="mx-auto my-[20px] w-[300px]">您尚未通过设备检测，可能影响上课，是否立即检测？</div>
      </Modal>
    </Fragment>
  )
}
